export default __webpack_public_path__ + "static/media/1218.7a010641.png";